// removed by extract-text-webpack-plugin
module.exports = {"root":"root___3kuI7"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Merchant/Commodity/SearchForm.less
// module id = 5tfX
// module chunks = 18